import { ErrorButton } from '@design/components/error-message/ErrorMessage';
import { NoDataFound } from '@terminal/components/no-data-found/NoDataFound';
import { useNewsSearchStore } from '@terminal/views/news/stores/use-news-search-store/useNewsSearchStore';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { ClearFiltersButton } from '../clear-filters-button/ClearFiltersButton';
import styles from './SearchEmptyStates.module.scss';

interface SearchEmptyStatesProps {
  buttonProps?: ErrorButton;
}

export const SearchEmptyStates = ({ buttonProps }: SearchEmptyStatesProps) => {
  const { t } = useTranslation('news');

  const [, setSearchParams] = useSearchParams();

  const { clearActiveFilters, clearSearch } = useNewsSearchStore(state => ({
    clearSearch: state.clearSearch,
    clearActiveFilters: state.clearActiveFilters,
  }));

  const handleClick = () => {
    clearActiveFilters(t);
    clearSearch();
    setSearchParams({});
  };

  return (
    <NoDataFound
      data-testid="search-empty-states"
      bannerPath="/app/static/images/empty-state/no-news.svg"
      title={t('news:emptySearch.title')}
      description={t('news:emptySearch.description')}
    >
      <div className={styles.buttonWrapper}>
        <ClearFiltersButton
          label={t('news:emptySearch.buttonLabel')}
          onClick={handleClick}
          {...buttonProps}
        />
      </div>
    </NoDataFound>
  );
};
